import GridTexsSortantController from './grid-texs-sortant.controller';
import Template from './grid-texs-sortant.html';

export default {
	bindings: {
		loading: '=',
		table: '=',
		pipe: '@'
	},
	controller: GridTexsSortantController,
	template: Template
};
